var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSfpCable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,70.75H30a.7502.7502,0,0,0,.75-.75V66.75H57a13.75,13.75,0,0,0,0-27.5H23a12.25,12.25,0,0,1,0-24.5H49.25V18a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V10A.7502.7502,0,0,0,70,9.25H50a.7502.7502,0,0,0-.75.75v3.25H23a13.75,13.75,0,0,0,0,27.5H57a12.25,12.25,0,0,1,0,24.5H30.75V62a.7502.7502,0,0,0-.75-.75H10a.7502.7502,0,0,0-.75.75v8A.7502.7502,0,0,0,10,70.75Zm40.75-60h18.5v6.5H50.75Zm-40,52h18.5v6.5H10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSfpCable);
export default __webpack_public_path__ + "static/media/icon_sfp_cable.d6bfec247222929edf4a1e45b324a0c0.svg";
export { ForwardRef as ReactComponent };